import { AddRoleSupervisorDocument, AddRoleSupervisorMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useAddRoleSupervisor = () => {
  const [mutate] = useMutation(AddRoleSupervisorDocument, {
    extractorFn: (data: AddRoleSupervisorMutation) =>
      data.jobCatalogMutations.addSupervisorsJobcatalogRole,
  })

  const addRoleSupervisor = (id: number, supervisorsIds: number[]) => {
    return mutate({ variables: { id, supervisorsIds } })
  }

  return addRoleSupervisor
}

export default useAddRoleSupervisor
